import Vue from 'vue'
import Vuex from 'vuex'
import router from '../router'
import { wxOAuthGetUserVo,getUserInfo } from "@/api/user";
Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    userData:{
      balance: 0,
      dayEstimate: 0,
      headUrl: "",
      level: "",
      monthEstimate: 0,
      nickName: "未登录",
      sumProfit: 0,
      userId: '',
      sumIncome	:0,
      aliPayCode:''
    },
    userId:''
  },
  mutations: {
    getUserData(state,obj){
      state.userData = obj
      state.userId = obj.userId//obj.userId
      sessionStorage.setItem("userId", obj.userId);
      router.replace(router.app.$route.path)
    },
    updateUserInfo(state,obj){
      state.userId = obj.userId// obj.userId'2527490572576073728'2543329275550637062
      state.userData = obj
    }
  },
  actions: {
    asyncGetUserData(context){
      var form = new FormData();
      const code = localStorage.getItem("code")
      form.append("code",code);   
      wxOAuthGetUserVo(form).then(res=>{
        context.commit('getUserData',res.data)

      })
    },
    asyncUpdateUserInfo(context,payload){
      var form2 = new FormData();
      form2.append("userId",payload.userId); 
      getUserInfo(form2).then(res=>{
        context.commit('updateUserInfo',res.data)
      }
      )      
    }
  },
  modules: {
  }
})
